import {
  txLastTransition,
  statesFromStateDescription,
  getTransitionsToStateFn,
  getTransitions,
  hasPassedTransition,
} from '../transaction';

//Extend-rental
export const TRANSITION_EXTEND_REQUEST_PAYMENT = 'transition/extend-request-payment';
export const TRANSITION_EXTEND_CONFIRM_PAYMENT = 'transition/extend-confirm-payment';
export const TRANSITION_EXTEND_PAYOUT_ADDITION_FEE = 'transition/extend-payout-addition-fee';
export const TRANSITION_EXTEND_DISPUTE = 'transition/extend-dispute';
export const TRANSITION_EXTEND_MARK_RETURN_ITEM = 'transition/extend-mark-return-item';
export const TRANSITION_ADMIN_EXTEND_MARK_RETURN_ITEM = 'transition/admin-extend-mark-return-item';
export const TRANSITION_EXTEND_EXPIRE_RETURN_ITEM = 'transition/extend-expire-return-item';
export const TRANSITION_EXTEND_REQUEST_EXTEND_BOOKING = 'transition/extend-request-extend-booking';
export const TRANSITION_EXTEND_MARK_RETURN_ITEM_AFTER_REQUEST_EXTEND_BOOKING =
  'transition/extend-mark-return-item-after-request-extend-booking';
export const TRANSITION_ADMIN_EXTEND_MARK_RETURN_ITEM_AFTER_REQUEST_EXTEND_BOOKING =
  'transition/admin-extend-mark-return-item-after-request-extend-booking';
export const TRANSITION_EXTEND_EXPIRE_RETURN_ITEM_AFTER_REQUEST_EXTEND_BOOKING =
  'transition/extend-expire-return-item-after-request-extend-booking';
export const TRANSITION_EXTEND_OFFER_EXTEND_BOOKING_DIRECTLY =
  'transition/extend-offer-extend-booking-directly';
export const TRANSITION_EXTEND_OFFER_EXTEND_BOOKING = 'transition/extend-offer-extend-booking';
export const TRANSITION_EXTEND_DECLINE_EXTEND_BOOKING = 'transition/extend-decline-extend-booking';
export const TRANSITION_EXTEND_EXPIRE_RETURN_ITEM_AFTER_OFFERED_EXTEND_BOOKING =
  'transition/extend-expire-return-item-after-offered-extend-booking';
export const TRANSITION_EXTEND_ACCEPT_EXTEND_BOOKING = 'transition/extend-accept-extend-booking';
export const TRANSITION_EXTEND_EXPIRE_PAYMENT = 'transition/extend-expire-payment';
export const TRANSITION_EXTEND_MARK_RETURN_ITEM_AFTER_OFFER_EXTEND_BOOKING =
  'transition/extend-mark-return-item-after-offer-extend-booking';
export const TRANSITION_ADMIN_EXTEND_MARK_RETURN_ITEM_AFTER_OFFER_EXTEND_BOOKING =
  'transition/admin-extend-mark-return-item-after-offer-extend-booking';
export const TRANSITION_EXTEND_SAVE_EXTEND_BOOKING = 'transition/extend-save-extend-booking';
export const TRANSITION_EXTEND_DISPUTE_AFTER_EXTEND_REQUEST_EXTEND_BOOKING =
  'transition/extend-dispute-after-extend-request-extend-booking';
export const TRANSITION_EXTEND_DISPUTE_AFTER_OFFERED_EXTEND_BOOKING =
  'transition/extend-dispute-after-offered-extend-booking';
export const TRANSITION_EXTEND_RESOLVED = 'transition/extend-resolved';
export const TRANSITION_EXTEND_REQUEST_PAYMENT_FREE = 'transition/extend-request-payment-free';

export const TRANSITION_EXTEND_EXPIRE = 'transition/extend-expire';
export const TRANSITION_EXTEND_DECLINE = 'transition/extend-decline';
export const TRANSITION_EXTEND_ADMIN_DECLINE = 'transition/extend-admin-decline';
export const TRANSITION_EXTEND_ACCEPT = 'transition/extend-accept';
export const TRANSITION_EXTEND_ADMIN_ACCEPT = 'transition/extend-admin-accept';

// Free extend
export const TRANSITION_EXTEND_FREE_EXPIRE = 'transition/extend-free-expire';
export const TRANSITION_EXTEND_FREE_DECLINE = 'transition/extend-free-decline';
export const TRANSITION_EXTEND_FREE_ADMIN_DECLINE = 'transition/extend-free-admin-decline';
export const TRANSITION_EXTEND_FREE_ACCEPT = 'transition/extend-free-accept';
export const TRANSITION_EXTEND_FREE_ADMIN_ACCEPT = 'transition/extend-free-admin-accept';

export const TRANSITION_EXTEND_RESCHEDULE = 'transition/extend-reschedule';
export const TRANSITION_ACCEPT_EXTEND_RESCHEDULE = 'transition/accept-extend-reschedule';
export const TRANSITION_EXPIRE_EXTEND_RESCHEDULE = 'transition/expire-extend-reschedule';
export const TRANSITION_CANCEL_EXTEND_RESCHEDULE = 'transition/cancel-extend-reschedule';
export const TRANSITION_EXPIRE_EXTEND_RESCHEDULE_ACCEPTANCE = 'transition/expire-extend-reschedule-acceptance';
export const TRANSITION_CONFIRM_EXTEND_RESCHEDULE_ACCEPTANCE = 'transition/confirm-extend-reschedule-acceptance';

// Free extend
export const TRANSITION_EXTEND_FREE_RESCHEDULE = 'transition/extend-free-reschedule';
export const TRANSITION_ACCEPT_EXTEND_FREE_RESCHEDULE = 'transition/accept-extend-free-reschedule';
export const TRANSITION_EXPIRE_EXTEND_FREE_RESCHEDULE = 'transition/expire-extend-free-reschedule';
export const TRANSITION_CANCEL_EXTEND_FREE_RESCHEDULE = 'transition/cancel-extend-free-reschedule';
export const TRANSITION_EXPIRE_EXTEND_FREE_RESCHEDULE_ACCEPTANCE = 'transition/expire-extend-free-reschedule-acceptance';
export const TRANSITION_CONFIRM_EXTEND_FREE_RESCHEDULE_ACCEPTANCE = 'transition/confirm-extend-free-reschedule-acceptance';

export const TRANSITION_ADMIN_CANCEL_EXTEND_BOOKING = 'transition/admin-cancel-extend-booking';
export const TRANSITION_ADMIN_CANCEL_EXTEND_FREE_BOOKING = 'transition/admin-cancel-extend-free-booking';

export const TRANSITION_MARK_EXTEND_PENDING_PAYMENT = 'transition/mark-extend-pending-payment';
export const TRANSITION_EXPIRE_EXTEND_PENDING_PAYMENT = 'transition/expire-extend-pending-payment';
export const TRANSITION_CREATE_EXTEND_PAYMENT = 'transition/create-extend-payment';
export const TRANSITION_ADMIN_CREATE_EXTEND_PAYMENT = 'transition/admin-create-extend-payment';
export const TRANSITION_AUTO_RECREATE_EXTEND_PAYMENT = 'transition/auto-recreate-extend-payment';
export const TRANSITION_ADMIN_CANCEL_PRE_CREATE_EXTEND_PAYMENT = 'transition/admin-cancel-pre-create-extend-payment';
export const TRANSITION_HOLD_CAPTURE_EXTEND_PAYMENT = 'transition/hold-capture-extend-payment';
export const TRANSITION_ADMIN_CANCEL_CREATED_EXTEND_PAYMENT = 'transition/admin-cancel-created-extend-payment';
export const TRANSITION_INITIATE_EXTEND_PAYMENT = 'transition/initiate-extend-payment';
export const TRANSITION_EXPIRE_EXTEND_PAYMENT = 'transition/expire-extend-payment';
export const TRANSITION_CONFIRM_EXTEND_PAYMENT = 'transition/confirm-extend-payment';
export const TRANSITION_ADMIN_CANCEL_PRE_AUTO_CAPTURE_EXTEND_PAYMENT = 'transition/admin-cancel-pre-auto-capture-extend-payment';
export const TRANSITION_AUTO_CAPTURE_EXTEND_PAYMENT = 'transition/auto-capture-extend-payment';
export const TRANSITION_EXTEND_TRANSFERRED = 'transition/extend-transferred';
export const TRANSITION_EXTEND_FREE_TRANSFERRED = 'transition/extend-free-transferred';

export const TRANSITION_EXTEND_COMPLETE_BOOKING = 'transition/extend-complete-booking';
//Extend state
const STATE_INITIAL = 'initial';
const STATE_PENDING_PAYMENT = 'pending-payment';
const STATE_REQUESTED = 'requested';
const STATE_RETURNED_ITEM = 'returned-item';
const STATE_PRE_BOOKING_EXTEND = 'pre-booking-extend';
const STATE_OFFERED_EXTEND_BOOKING = 'offered-extend-booking';
const STATE_EXTENDED_BOOKING = 'extended-booking';
const STATE_CONFIRMED_EXTEND_PAYMENT = 'confirmed-extend-payment';
const STATE_EXTENSION_DELIVERED = 'extension-delivered';
const STATE_EXTEND_DISPUTED = 'extend-disputed';
const STATE_EXTEND_REQUESTED = 'extend-requested';
const STATE_EXTEND_FREE_REQUESTED = 'extend-free-requested';
const STATE_EXTEND_ACCEPTED = 'extend-accepted';
const STATE_EXTEND_RESCHEDULED = 'extend-rescheduled';
const STATE_EXTEND_RESCHEDULE_ACCEPTED = 'extend-reschedule-accepted';
const STATE_EXTEND_DECLINED = 'extend-declined';
const STATE_EXTEND_FREE_RESCHEDULED = 'extend-free-rescheduled';
const STATE_EXTEND_FREE_RESCHEDULE_ACCEPTED = 'extend-free-reschedule-accepted';
const STATE_EXTEND_FREE_ACCEPTED = 'extend-free-accepted';
const STATE_PRE_CREATE_EXTEND_PAYMENT = 'pre-create-extend-payment';
const STATE_CREATED_EXTEND_PAYMENT = 'created-extend-payment';
const STATE_PRE_AUTO_CAPTURE_EXTEND_PAYMENT = 'pre-auto-capture-extend-payment';
const STATE_PENDING_EXTEND_PAYMENT = 'pending-extend-payment';
const STATE_EXTEND_PAYMENT_EXPIRED = 'extend-payment-expired';
const STATE_EXTEND_CANCELLED = 'extend-cancelled';
const STATE_COMPLETE_BOOKING = 'complete-booking';
const STATE_PAYMENT_EXPIRED = 'payment-expired';
const STATE_EXTENDED_CONFIRMED_PAYMENT = 'extended-confirmed-payment';

//Extend state description
const stateDescription = {
  // id is defined only to support Xstate format.
  // However if you have multiple transaction processes defined,
  // it is best to keep them in sync with transaction process aliases.
  id: 'flex-default-process/release-1',

  // This 'initial' state is a starting point for new transaction
  initial: STATE_INITIAL,

  // States
  states: {
    [STATE_INITIAL]: {
      on: {
        [TRANSITION_EXTEND_REQUEST_PAYMENT]: STATE_EXTEND_REQUESTED,
        [TRANSITION_EXTEND_REQUEST_PAYMENT_FREE]: STATE_EXTEND_FREE_REQUESTED,
      },
    },
    [STATE_EXTEND_REQUESTED]: {
      on: {
        [TRANSITION_EXTEND_EXPIRE]: STATE_EXTEND_DECLINED,
        [TRANSITION_EXTEND_DECLINE]: STATE_EXTEND_DECLINED,
        [TRANSITION_EXTEND_ADMIN_DECLINE]: STATE_EXTEND_DECLINED,
        [TRANSITION_EXTEND_ACCEPT]: STATE_EXTEND_ACCEPTED,
        [TRANSITION_EXTEND_ADMIN_ACCEPT]: STATE_EXTEND_ACCEPTED,
        [TRANSITION_EXTEND_RESCHEDULE]: STATE_EXTEND_RESCHEDULED,
      },
    },
    [STATE_EXTEND_RESCHEDULED]: {
      on: {
        [TRANSITION_ACCEPT_EXTEND_RESCHEDULE]: STATE_EXTEND_RESCHEDULE_ACCEPTED,
        [TRANSITION_EXPIRE_EXTEND_RESCHEDULE]: STATE_EXTEND_DECLINED,
        [TRANSITION_CANCEL_EXTEND_RESCHEDULE]: STATE_EXTEND_DECLINED,
      },
    },
    [STATE_EXTEND_RESCHEDULE_ACCEPTED]: {
      on: {
        [TRANSITION_EXPIRE_EXTEND_RESCHEDULE_ACCEPTANCE]: STATE_EXTEND_DECLINED,
        [TRANSITION_CONFIRM_EXTEND_RESCHEDULE_ACCEPTANCE]: STATE_EXTEND_ACCEPTED,
      },
    },
    [STATE_EXTEND_FREE_REQUESTED]: {
      on: {
        [TRANSITION_EXTEND_FREE_EXPIRE]: STATE_EXTEND_DECLINED,
        [TRANSITION_EXTEND_FREE_DECLINE]: STATE_EXTEND_DECLINED,
        [TRANSITION_EXTEND_FREE_ADMIN_DECLINE]: STATE_EXTEND_DECLINED,
        [TRANSITION_EXTEND_FREE_ACCEPT]: STATE_EXTEND_FREE_ACCEPTED,
        [TRANSITION_EXTEND_FREE_ADMIN_ACCEPT]: STATE_EXTEND_FREE_ACCEPTED,
        [TRANSITION_EXTEND_FREE_RESCHEDULE]: STATE_EXTEND_FREE_RESCHEDULED,
      },
    },
    [STATE_EXTEND_FREE_RESCHEDULED]: {
      on: {
        [TRANSITION_ACCEPT_EXTEND_FREE_RESCHEDULE]: STATE_EXTEND_FREE_RESCHEDULE_ACCEPTED,
        [TRANSITION_EXPIRE_EXTEND_FREE_RESCHEDULE]: STATE_EXTEND_DECLINED,
        [TRANSITION_CANCEL_EXTEND_FREE_RESCHEDULE]: STATE_EXTEND_DECLINED,
      },
    },
    [STATE_EXTEND_FREE_RESCHEDULE_ACCEPTED]: {
      on: {
        [TRANSITION_EXPIRE_EXTEND_FREE_RESCHEDULE_ACCEPTANCE]: STATE_EXTEND_DECLINED,
        [TRANSITION_CONFIRM_EXTEND_FREE_RESCHEDULE_ACCEPTANCE]: STATE_EXTEND_FREE_ACCEPTED,
      },
    },
    [STATE_EXTEND_ACCEPTED]: {
      on: {
        [TRANSITION_ADMIN_CANCEL_EXTEND_BOOKING]: STATE_EXTEND_CANCELLED,
        [TRANSITION_MARK_EXTEND_PENDING_PAYMENT]: STATE_PRE_CREATE_EXTEND_PAYMENT,
      },
    },
    [STATE_EXTEND_FREE_ACCEPTED]: {
      on: {
        [TRANSITION_ADMIN_CANCEL_EXTEND_FREE_BOOKING]: STATE_EXTEND_CANCELLED,
        [TRANSITION_ADMIN_CANCEL_EXTEND_FREE_BOOKING]: TRANSITION_EXTEND_FREE_TRANSFERRED,
      },
    },
    [STATE_PRE_CREATE_EXTEND_PAYMENT]: {
      on: {
        [TRANSITION_EXPIRE_EXTEND_PENDING_PAYMENT]: STATE_EXTEND_CANCELLED,
        [TRANSITION_ADMIN_CANCEL_PRE_CREATE_EXTEND_PAYMENT]: STATE_EXTEND_CANCELLED,
        [TRANSITION_CREATE_EXTEND_PAYMENT]: STATE_CREATED_EXTEND_PAYMENT,
        [TRANSITION_ADMIN_CREATE_EXTEND_PAYMENT]: STATE_CREATED_EXTEND_PAYMENT,
        [TRANSITION_AUTO_RECREATE_EXTEND_PAYMENT]: STATE_CREATED_EXTEND_PAYMENT,
        [TRANSITION_INITIATE_EXTEND_PAYMENT]: STATE_PENDING_EXTEND_PAYMENT,
      },
    },
    [STATE_CREATED_EXTEND_PAYMENT]: {
      on: {
        [TRANSITION_HOLD_CAPTURE_EXTEND_PAYMENT]: STATE_PRE_AUTO_CAPTURE_EXTEND_PAYMENT,
        [TRANSITION_ADMIN_CANCEL_CREATED_EXTEND_PAYMENT]: STATE_EXTEND_CANCELLED,
      },
    },
    [STATE_PRE_AUTO_CAPTURE_EXTEND_PAYMENT]: {
      on: {
        [TRANSITION_AUTO_CAPTURE_EXTEND_PAYMENT]: STATE_CONFIRMED_EXTEND_PAYMENT,
        [TRANSITION_ADMIN_CANCEL_PRE_AUTO_CAPTURE_EXTEND_PAYMENT]: STATE_EXTEND_CANCELLED,
      },
    },
    [STATE_PENDING_EXTEND_PAYMENT]: {
      on: {
        [TRANSITION_EXPIRE_EXTEND_PAYMENT]: STATE_EXTEND_PAYMENT_EXPIRED,
        [TRANSITION_CONFIRM_EXTEND_PAYMENT]: STATE_PRE_AUTO_CAPTURE_EXTEND_PAYMENT,
      },
    },
    [STATE_CONFIRMED_EXTEND_PAYMENT]: {
      on: {
        [TRANSITION_EXTEND_TRANSFERRED]: STATE_EXTENSION_DELIVERED,
      },
    },
    [STATE_EXTENSION_DELIVERED]: {
      on: {
        [TRANSITION_EXTEND_DISPUTE]: STATE_EXTEND_DISPUTED,
        [TRANSITION_EXTEND_MARK_RETURN_ITEM]: STATE_RETURNED_ITEM,
        [TRANSITION_ADMIN_EXTEND_MARK_RETURN_ITEM]: STATE_RETURNED_ITEM,
        [TRANSITION_EXTEND_EXPIRE_RETURN_ITEM]: STATE_RETURNED_ITEM,
        [TRANSITION_EXTEND_OFFER_EXTEND_BOOKING_DIRECTLY]: STATE_OFFERED_EXTEND_BOOKING,
      },
    },
    [STATE_RETURNED_ITEM]: {
      on: {
        [TRANSITION_EXTEND_COMPLETE_BOOKING]: STATE_RETURNED_ITEM,
      }
    },
    [STATE_COMPLETE_BOOKING]: {type: 'final'},
    [STATE_PRE_BOOKING_EXTEND]: {
      on: {
        [TRANSITION_EXTEND_MARK_RETURN_ITEM_AFTER_REQUEST_EXTEND_BOOKING]: STATE_RETURNED_ITEM,
        [TRANSITION_ADMIN_EXTEND_MARK_RETURN_ITEM_AFTER_REQUEST_EXTEND_BOOKING]: STATE_RETURNED_ITEM,
        [TRANSITION_EXTEND_EXPIRE_RETURN_ITEM_AFTER_REQUEST_EXTEND_BOOKING]: STATE_RETURNED_ITEM,
        [TRANSITION_EXTEND_OFFER_EXTEND_BOOKING]: STATE_OFFERED_EXTEND_BOOKING,
        [TRANSITION_EXTEND_DISPUTE_AFTER_EXTEND_REQUEST_EXTEND_BOOKING]: STATE_EXTEND_DISPUTED,
      },
    },
    [STATE_OFFERED_EXTEND_BOOKING]: {
      on: {
        [TRANSITION_EXTEND_DECLINE_EXTEND_BOOKING]: STATE_OFFERED_EXTEND_BOOKING,
        [TRANSITION_EXTEND_SAVE_EXTEND_BOOKING]: STATE_OFFERED_EXTEND_BOOKING,
        [TRANSITION_EXTEND_ACCEPT_EXTEND_BOOKING]: STATE_EXTENDED_BOOKING,
        [TRANSITION_EXTEND_EXPIRE_RETURN_ITEM_AFTER_OFFERED_EXTEND_BOOKING]: STATE_RETURNED_ITEM,
        [TRANSITION_EXTEND_MARK_RETURN_ITEM_AFTER_OFFER_EXTEND_BOOKING]: STATE_RETURNED_ITEM,
        [TRANSITION_ADMIN_EXTEND_MARK_RETURN_ITEM_AFTER_OFFER_EXTEND_BOOKING]: STATE_RETURNED_ITEM,
        [TRANSITION_EXTEND_DISPUTE_AFTER_OFFERED_EXTEND_BOOKING]: STATE_EXTEND_DISPUTED,
      },
    },
    [STATE_EXTEND_DISPUTED]: {
      on: {
        [TRANSITION_EXTEND_RESOLVED]: STATE_RETURNED_ITEM,
      },
    },
    [STATE_EXTENDED_BOOKING]: {},
    [STATE_RETURNED_ITEM]: { on: { [TRANSITION_EXTEND_COMPLETE_BOOKING]: STATE_COMPLETE_BOOKING } },
    [STATE_COMPLETE_BOOKING]: { type: 'final' },
  },
};

// This is a list of all the transitions that this app should be able to handle.
export const EXTEND_TRANSITIONS = getTransitions(statesFromStateDescription(stateDescription)).map(
  t => t.key
);

// Get all the transitions that lead to specified state.
const getTransitionsToState = getTransitionsToStateFn(stateDescription);

export const hasPassedStateFn = state => tx =>
  getTransitionsToState(state).filter(t => hasPassedTransition(t, tx)).length > 0;

// This is needed to fetch transactions that need response from provider.
// I.e. transactions which provider needs to accept or decline
export const transitionsToRequested = getTransitionsToState(STATE_REQUESTED);

export const exTxIsOfferExtendBooking = tx => {
  const lastTransition = txLastTransition(tx);
  return (
    lastTransition === TRANSITION_EXTEND_OFFER_EXTEND_BOOKING ||
    lastTransition === TRANSITION_EXTEND_OFFER_EXTEND_BOOKING_DIRECTLY
  );
};

export const exTxIsExpirePayment = tx => txLastTransition(tx) === TRANSITION_EXTEND_EXPIRE_PAYMENT;

export const exTxIsRequestPayment = tx =>
  txLastTransition(tx) === TRANSITION_EXTEND_REQUEST_PAYMENT;

export const exTxIsPendingPayment = tx =>
  getTransitionsToState(STATE_PENDING_PAYMENT).includes(txLastTransition(tx));

export const isPrivileged = transition => {
  return [TRANSITION_EXTEND_REQUEST_PAYMENT, TRANSITION_EXTEND_MARK_RETURN_ITEM].includes(
    transition
  );
};

export const exTxIsDisputed = tx =>
  getTransitionsToState(STATE_EXTEND_DISPUTED).includes(txLastTransition(tx));

export const exTxIsConfirmedPayment = tx =>
  getTransitionsToState(STATE_EXTENDED_CONFIRMED_PAYMENT).includes(txLastTransition(tx));

export const exTxIsDelivered = tx =>
  getTransitionsToState(STATE_EXTENSION_DELIVERED).includes(txLastTransition(tx));

export const exTxIsReturnedItem = tx =>
  getTransitionsToState(STATE_RETURNED_ITEM).includes(txLastTransition(tx));

export const exTxIsExtendedBooking = tx =>
  getTransitionsToState(STATE_EXTENDED_BOOKING).includes(txLastTransition(tx));

export const exTxIsCompleteBooking = tx =>
  getTransitionsToState(STATE_COMPLETE_BOOKING).includes(txLastTransition(tx));

export const exTxIsRequested = tx =>
  [
    ...getTransitionsToState(STATE_EXTEND_REQUESTED),
    ...getTransitionsToState(STATE_EXTEND_FREE_REQUESTED),
  ].includes(txLastTransition(tx));

export const exTxIsRescheduled = tx =>
[
  ...getTransitionsToState(STATE_EXTEND_RESCHEDULED),
  ...getTransitionsToState(STATE_EXTEND_FREE_RESCHEDULED),
].includes(txLastTransition(tx));

export const exTxIsRescheduleAccepted = tx =>
[
  ...getTransitionsToState(STATE_EXTEND_RESCHEDULE_ACCEPTED),
  ...getTransitionsToState(STATE_EXTEND_FREE_RESCHEDULE_ACCEPTED),
].includes(txLastTransition(tx));

export const exTxIsAccepted = tx =>
[
  ...getTransitionsToState(STATE_EXTEND_ACCEPTED),
  ...getTransitionsToState(STATE_EXTEND_FREE_ACCEPTED),
].includes(txLastTransition(tx));

export const exTxIsDeclined = tx =>
  getTransitionsToState(STATE_EXTEND_DECLINED).includes(txLastTransition(tx));

export const exTxIsCanceled = tx =>
  getTransitionsToState(STATE_EXTEND_CANCELLED).includes(txLastTransition(tx));

export const isExtendBooking = tx =>
[
  TRANSITION_EXTEND_REQUEST_PAYMENT,
  TRANSITION_EXTEND_REQUEST_PAYMENT_FREE,
].reduce((prev, cur) => prev || hasPassedTransition(cur, tx), '');

export const getExtendTxCanReschedule = (extendTransactions = []) => {
  return extendTransactions.find(tx =>
    tx.attributes.lastTransition === TRANSITION_EXTEND_REQUEST_PAYMENT ||
    tx.attributes.lastTransition === TRANSITION_EXTEND_REQUEST_PAYMENT_FREE)
}

//Helper
export const isExRelevantPastTransition = transition => {
  return [
    TRANSITION_EXTEND_REQUEST_EXTEND_BOOKING,
    TRANSITION_EXTEND_DISPUTE,
    TRANSITION_EXTEND_DISPUTE_AFTER_OFFERED_EXTEND_BOOKING,
    TRANSITION_EXTEND_DISPUTE_AFTER_EXTEND_REQUEST_EXTEND_BOOKING,
    TRANSITION_EXTEND_MARK_RETURN_ITEM,
    TRANSITION_EXTEND_EXPIRE_RETURN_ITEM,
    TRANSITION_EXTEND_MARK_RETURN_ITEM_AFTER_REQUEST_EXTEND_BOOKING,
    TRANSITION_EXTEND_EXPIRE_RETURN_ITEM_AFTER_REQUEST_EXTEND_BOOKING,
    TRANSITION_EXTEND_MARK_RETURN_ITEM_AFTER_OFFER_EXTEND_BOOKING,
    TRANSITION_EXTEND_EXPIRE_RETURN_ITEM_AFTER_OFFERED_EXTEND_BOOKING,
    TRANSITION_EXTEND_OFFER_EXTEND_BOOKING_DIRECTLY,
    TRANSITION_EXTEND_OFFER_EXTEND_BOOKING,
    TRANSITION_EXTEND_DECLINE_EXTEND_BOOKING,
    TRANSITION_EXTEND_ACCEPT_EXTEND_BOOKING,
    TRANSITION_EXTEND_EXPIRE_PAYMENT,
    TRANSITION_ADMIN_EXTEND_MARK_RETURN_ITEM,
    TRANSITION_ADMIN_EXTEND_MARK_RETURN_ITEM_AFTER_REQUEST_EXTEND_BOOKING,
    TRANSITION_ADMIN_EXTEND_MARK_RETURN_ITEM_AFTER_OFFER_EXTEND_BOOKING,
  ].includes(transition);
};

export const END_EX_TRANSACTION_TRANSITIONS = [
  ...getTransitionsToState(STATE_COMPLETE_BOOKING),
  ...getTransitionsToState(STATE_EXTENDED_BOOKING),
  // ...getTransitionsToState(STATE_EXTEND_CANCELLED),
  // ...getTransitionsToState(STATE_EXTEND_DECLINED),
  // ...getTransitionsToState(STATE_EXTEND_PAYMENT_EXPIRED),
];

export const ONGOING_EX_TRANSACTION_TRANSITIONS = EXTEND_TRANSITIONS.filter(
  transition => !END_EX_TRANSACTION_TRANSITIONS.includes(transition)
);
